module.exports = __webpack_public_path__ + "img/smartiot_1.fa33ae79.png";